import { useEffect, useState } from "react";
import { useLang } from "@/hooks/use-language";

const STORAGE_KEY = "jozori_consent_v1";

export type ConsentValue = "accepted" | "rejected";

export function getConsent(): ConsentValue | null {
  if (typeof window === "undefined") return null;
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === "accepted" || v === "rejected" ? v : null;
}

export function setConsent(v: ConsentValue) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, v);
  window.dispatchEvent(new CustomEvent("jozori:consent", { detail: v }));
}

export function CookieConsent() {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(getConsent() === null);
  }, []);

  if (!show) return null;

  const isAr = lang === "ar";

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-cookie-consent
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-2xl border border-border bg-background/95 p-4 shadow-2xl backdrop-blur md:inset-x-auto md:right-4 md:left-auto md:bottom-4"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <p className="text-sm text-foreground">
          {isAr
            ? "نستخدم ملفات تعريف الارتباط لتحسين تجربتك وقياس الأداء. يمكنك القبول أو الرفض في أي وقت."
            : "We use cookies to improve your experience and measure performance. You can accept or reject at any time."}
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => {
              setConsent("rejected");
              setShow(false);
            }}
            className="rounded-md border border-input bg-background px-3 py-1.5 text-sm font-medium hover:bg-accent"
          >
            {isAr ? "رفض" : "Reject"}
          </button>
          <button
            onClick={() => {
              setConsent("accepted");
              setShow(false);
            }}
            className="rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            {isAr ? "قبول" : "Accept"}
          </button>
        </div>
      </div>
    </div>
  );
}
